import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchContinents: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'continent/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_CONTINENT_REQUEST,
                        types.SEARCH_CONTINENT_SUCCESS,
                        types.SEARCH_CONTINENT_FAILURE
                    ]
                }
            });
        },

    saveContinent: (continent) =>
        (dispatch) => {
            if (continent.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'continent/create',
                        method: 'POST',
                        body: continent,
                        types: [
                            types.CREATE_CONTINENT_REQUEST,
                            types.CREATE_CONTINENT_SUCCESS,
                            types.CREATE_CONTINENT_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'continent/update',
                        method: 'PUT',
                        body: continent,
                        types: [
                            types.UPDATE_CONTINENT_REQUEST,
                            types.UPDATE_CONTINENT_SUCCESS,
                            types.UPDATE_CONTINENT_FAILURE
                        ]
                    }
                });
            }
        }
}
